import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ROUTES_APP } from '../../../../../app.routes';
import { StorageService } from '@shared/services/index';
import { CentroMedico } from '@shared/interfaces/perfil.interface';
import { StorageKeys, StorageType } from '../../../../../shared/enums';

@Component({
  selector: 'soph-change-medical-center',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './change-medical-center.component.html',
  styleUrl: './change-medical-center.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangeMedicalCenterComponent {
  private readonly iconRegistry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly router = inject(Router);
  private readonly storage = inject(StorageService);

  constructor() {
    this.iconRegistry.addSvgIcon(
      'hospital',
      this.sanitizer.bypassSecurityTrustResourceUrl(`assets/icons-v2/hospital.svg`)
    );
    this.iconRegistry.addSvgIcon(
      'swap-horizontal',
      this.sanitizer.bypassSecurityTrustResourceUrl(`assets/icons-v2/swap-horizontal.svg`)
    );
  }

  protected getCurrentMedicalCenter(): CentroMedico | null {
    return this.storage.getItem<CentroMedico>(StorageKeys.CURRENT_MEDICAL_CENTER, StorageType.LOCAL);
  }

  protected goToMedicalCenters(): void {
    this.router.navigate([ROUTES_APP.MEDICAL_CENTERS], { replaceUrl: true });
  }

}
